import PageHeader from "../components/PageHeader";

const CONTENT = {
  privacy: {
    eyebrow: "Legal",
    title: "Privacy Policy",
    sub: "How Nova SecureNet collects, uses, and protects your information.",
    sections: [
      ["Information we collect", "We collect the details you provide through our contact form — such as your name, company, email, phone number, and project information — solely to respond to your inquiry and provide our services."],
      ["How we use your information", "Your information is used to communicate with you about your project, deliver services, and improve our offering. We never sell your data to third parties."],
      ["Data protection", "We apply reasonable technical and organizational measures to keep your information secure. Access is limited to team members who need it to serve you."],
      ["Your rights", "You may request access to, correction of, or deletion of your personal information at any time by contacting us at matthew@novasecurenet.com."],
    ],
  },
  terms: {
    eyebrow: "Legal",
    title: "Terms of Service",
    sub: "The terms that govern the use of the Nova SecureNet website and services.",
    sections: [
      ["Services", "Nova SecureNet provides website development, digital security, and IT solutions. Specific deliverables, pricing, and timelines are agreed in writing before a project begins."],
      ["Payments", "Project fees and recurring care plan fees are outlined in your proposal. Recurring plans continue until cancelled with reasonable notice."],
      ["Ownership", "Upon full payment for a build, ownership of the delivered website transfers to the client unless otherwise agreed."],
      ["Limitation of liability", "We work diligently to deliver quality results, but Nova SecureNet is not liable for indirect or consequential damages arising from use of our services."],
    ],
  },
};

export default function LegalPage({ type }) {
  const c = CONTENT[type];
  return (
    <div data-testid={`legal-${type}`}>
      <PageHeader eyebrow={c.eyebrow} title={c.title} sub={c.sub} />
      <section className="mx-auto max-w-3xl px-5 pb-24 lg:px-8">
        <div className="space-y-8">
          {c.sections.map(([h, b]) => (
            <div key={h} className="rounded-2xl border border-white/10 bg-white/[0.03] p-7">
              <h3 className="font-heading text-lg font-semibold text-white">{h}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{b}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
